var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_an-object.js
// module id = 15
// module chunks = 0